module.exports = __webpack_public_path__ + "img/doc.248dbda4.png";